import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useConsumer } from '~/context/common/StaticContext';
import UserContext from '~/context/common/UserContext';

const formatConsumerIntoEventName = (str: string) =>
  str
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export default function useSendViewedEvent() {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    userState: { isLoaded: isUserLoaded }
  } = useContext(UserContext);
  const consumer = useConsumer();

  useEffectOnce(
    () => {
      trackEvent(`${formatConsumerIntoEventName(consumer)} Page Viewed`);
    },
    [consumer, trackEvent],
    isUserLoaded
  );
}
